const ATTENDANCE_CYCLES_TABLE_READY = "attendance-cycles-table-ready"
const SEARCH_TEXT_STATE = "attendance-cycles-table-search-text-state"
const ROWS_PER_PAGE_STATE = "attendance-cycles-table-rows-per-page-state"
const PAGINATION_STATE = "attendance-cycles-table-pagination-state"

const ATTENDANCE_CYCLES_ID_FOR_ACTION = "attendance-cycles-table-attendanceCycles-id-for-action"


const initialState = {
    isAttendanceCyclesTableReady: true,
    attendance_cycles: {},

    
    attendanceCyclesSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ATTENDANCE_CYCLES_TABLE_READY:
            return Object.assign({}, state, { isAttendanceCyclesTableReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case ATTENDANCE_CYCLES_ID_FOR_ACTION:
            return Object.assign({}, state, {attendanceCyclesSelectedId:action.payload})

        default:
        return state
    
    }

}

export function attendanceCyclesTableReady(data) {
    return {
        type: ATTENDANCE_CYCLES_TABLE_READY,
        payload: data
    }
}

export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function attendanceCyclesIdForAction(attendanceCyclesId){
    return{
        type:ATTENDANCE_CYCLES_ID_FOR_ACTION,
        payload:attendanceCyclesId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Attendance Cycles/redux/attendance_cycles.js